import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import './style.css';
import { IonIcon } from '@ionic/react';
const VnButton = ({ mode, icon, customClassName = '', customIconClassName = '', size = 'md', isDisabled, text, ...props }) => {
    const buttonClass = size === 'md'
        ? `Vn-button Vn-button-md Vn-button-${mode}`
        : size === 'lg'
            ? `Vn-button Vn-button-lg Vn-button-${mode}`
            : `Vn-button-sm Vn-button-sm-${mode}`;
    const buttonDisabled = isDisabled ? 'Vn-button-disabled' : '';
    return (_jsx("button", { className: `${customClassName} ${buttonClass} ${buttonDisabled}`, disabled: isDisabled, ...props, children: _jsxs("span", { children: [!!icon && !text && _jsx(IonIcon, { className: `vn-icon ${customIconClassName}`, icon: icon }), !!icon && text && (_jsxs(_Fragment, { children: [_jsx(IonIcon, { className: `vn-icon-with-text ${customIconClassName}`, icon: icon }), _jsx("h5", { className: 'vn-button-text', children: text })] })), ' ', props.children] }) }));
};
export default VnButton;
